__turbopack_context__.v({
  "className": "rubik_f6a65110-module__SVCQWG__className",
  "variable": "rubik_f6a65110-module__SVCQWG__variable",
});
